import { useEffect, useState } from 'react';

import { startResult } from '@webapp/account/src/resources/reports';

import { Button } from '@webapp/common/components/button';
import { Textfield, TextfieldType } from '@webapp/common/components/textfield';
import { useActions } from '@webapp/common/hooks/use-actions';
import { delCookie, getCookie, PDF_SHARE_TOKEN, setCookie, SHARE_TOKEN } from '@webapp/common/lib/cookies';

import { PublicResultsContent } from './public-content';

import css from './public.css';

const host = window.location.host;
const subdomain = host.split('.')[0];
const urlParams = new URLSearchParams(window.location.search);
const shareUrl = urlParams.get('linkId');

export const PublicResults: FC = () => {
    const [started, setStarted] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [password, setPassword] = useState<string>('');

    const start = useActions(startResult);

    useEffect(() => {
        const pdfShareToken = getCookie(PDF_SHARE_TOKEN);

        if (pdfShareToken) {
            // Рендер pdf: пароль уже вводил пользователь в браузере, используем
            // его shareToken вместо повторной авторизации.
            setCookie(SHARE_TOKEN, pdfShareToken, {
                path: '/',
            });
        } else {
            delCookie(SHARE_TOKEN, {
                path: '/',
            });
        }

        start({ shareUrl: shareUrl, surveyUrl: subdomain }).then((resp) => {
            if (resp.payload.shareToken) {
                setCookie(SHARE_TOKEN, resp.payload.shareToken, {
                    path: '/',
                });
                setStarted(true);
            } else if (resp.payload.passwordAccess) {
                setShowPassword(true);
            }
        });
    }, [start]);

    if (showPassword) {
        return (
            <div className={css.password}>
                <h2>Для входа введите пароль</h2>
                <div className={css.passwordInputs}>
                    <Textfield
                        value={password}
                        onChange={setPassword}
                        className={css.passwordInput}
                        placeholder='Пароль'
                        type={TextfieldType.PASSWORD}
                        autoComplete='off'
                    />
                    <Button
                        color='blue'
                        onClick={() => {
                            start({ shareUrl: shareUrl, surveyUrl: subdomain, password }).then((resp) => {
                                if (resp.payload.shareToken) {
                                    setCookie(SHARE_TOKEN, resp.payload.shareToken, {
                                        path: '/',
                                    });
                                    setShowPassword(false);
                                    setStarted(true);
                                }
                            });
                        }}
                    >
                        Войти
                    </Button>
                </div>
            </div>
        );
    }

    if (!started) return null;

    return <PublicResultsContent />;
};
